<div class="card-layout">
  <!-- Header Section -->
  <div class="d-flex flex-row align-items-center psic-gap-4">
    <img
      src="../../../../assets/images/payment-info/payment-history.svg"
      alt="payment-history"
      class="card-image"
    />
    <div class="card-header">Payment Receipts</div>
    @if (isLoading()) {
    <app-card-loader></app-card-loader>
    }
  </div>

  @if (!isLoading() && !dmsFailed) {
  <div class="separator"></div>

  <!-- Content section -->
  @if (paymentReceiptsCount() > 0) {
  <div class="d-flex flex-column psic-gap-6">
    <!-- Payment Receipt Section -->
    @if (paymentReceiptsCount() > 0) { @for (receipt of paymentReceiptsList(); track
    receipt.attachmentDocId) {
    <div class="d-flex flex-column">
      <div
        class="d-flex flex-row justify-content-between align-items-center"
        [class.psic-p-2]="isMobile()"
      >
        <div class="d-flex flex-column psic-gap-1">
          @if (isMobile()) {
          <span class="caption-bold">{{ receipt.receivedDate | date : 'MM/dd/yyyy' }}</span>
          <span class="caption">{{ receipt.subCategory }}</span>
          } @else {
          <p class="alt-bold">{{ receipt.receivedDate | date : 'MM/dd/yyyy' }}</p>
          <p class="alt">{{ receipt.subCategory }}</p>
          }
        </div>

        @if (receipt.attachmentDocId) {
        <mat-icon
          [svgIcon]="'download'"
          class="p1-50-color pointerCursor"
          [class.mat-icon-24]="isMobile()"
          (click)="downloadFile(receipt.attachmentDocId, receipt.fileName)"
        ></mat-icon>
        }
      </div>
      <div class="separator"></div>
    </div>
    } } @else {
    <p class="caption psic-mt-4">No payment receipts available.</p>
    }

    <!-- Show more/less toggle -->
    @if (paymentReceiptsCount() > showMoreDataLimit) {
    <div class="d-flex flex-row justify-content-center align-items-center">
      <lib-button
        [buttonText]="showMoreReceipts() ? 'Show less' : 'Show more'"
        buttonType="borderless"
        [libIcon]="showMoreReceipts() ? 'minus-circle' : 'add-circle'"
        (callback)="onShowPaymentsReceipts()"
      ></lib-button>
    </div>
    }
  </div>
  } @else {
  <lib-alert
    alertText="No payment receipts available."
    [alertTheme]="'default'"
    [alertType]="'small'"
  ></lib-alert>
  } }
</div>
